import React from 'react';
import PropTypes from "prop-types";

const StatusBuildingFormatRenderer = (props) => {
  const value = props.value
  const {building} = props.data
  let textCss = "tw-text-blue-600"

  switch(building?.status_id) {
    case 1:
    case 2:
    case 12:
      textCss = "tw-text-red-600"
      break
  }
  return <span className={textCss}>{value}</span>
};

StatusBuildingFormatRenderer.propTypes = {
  value: PropTypes.string.isRequired,
  data: PropTypes.shape({
    building: PropTypes.shape({
      status_id: PropTypes.number
    })
  })
};

export default StatusBuildingFormatRenderer;